export function uuidv4(){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export function range(start, end){
    return new Array(end - start + 1).fill().map((_, i) => i + start)
}

export function userName(user) {
    return user.FirstName + ' ' + user.LastName
}

export const download = (dataUrl, fileName) => {
    let link = document.createElement('a');
    link.download = fileName;
    link.href = dataUrl;
    link.click();
}

export const timelog = (...params) => {
    const d = new Date()
    console.log(d.toLocaleTimeString() + '.' + d.getMilliseconds(), ...params)
}